// D&D 5e SRD 5.2.1 (CC BY 4.0 — Wizards of the Coast)
// Solo i feat presenti nell'SRD 5.2.1

export const DND_FEATS = {
  origin: [
    {
      id: 'alert',
      name: 'Alert',
      category: 'origin',
      prerequisite: null,
      repeatable: false,
      asi: null,
      desc: 'Initiative Proficiency: Add your Proficiency Bonus to Initiative rolls. Initiative Swap: Immediately after rolling Initiative, you can swap your Initiative with one willing ally in the same combat (not if either has Incapacitated condition).',
    },
    {
      id: 'magic_initiate',
      name: 'Magic Initiate',
      category: 'origin',
      prerequisite: null,
      repeatable: true,
      repeatableNote: 'Must choose a different spell list each time.',
      asi: null,
      choices: {
        spellList: ['Cleric', 'Druid', 'Wizard'],
        cantrips: 2,
        spells: 1,
        spellLevel: 1,
        spellcastingStat: 'choice',
      },
      desc: 'Learn 2 cantrips and 1 level 1 spell from Cleric, Druid, or Wizard list. Cast the level 1 spell once per Long Rest without a slot. Spellcasting ability is INT, WIS, or CHA (choose when taking this feat).',
    },
    {
      id: 'savage_attacker',
      name: 'Savage Attacker',
      category: 'origin',
      prerequisite: null,
      repeatable: false,
      asi: null,
      desc: "Once per turn when you hit a target with a weapon, you can roll the weapon's damage dice twice and use either roll.",
    },
    {
      id: 'skilled',
      name: 'Skilled',
      category: 'origin',
      prerequisite: null,
      repeatable: true,
      repeatableNote: 'Can be taken multiple times.',
      asi: null,
      choices: { skills: 3 },
      desc: 'Gain proficiency in any combination of 3 skills or tools of your choice.',
    },
  ],

  general: [
    {
      id: 'ability_score_improvement',
      name: 'Ability Score Improvement',
      category: 'general',
      prerequisite: 'Level 4+',
      repeatable: true,
      asi: 'choice',
      asiOptions: 'standard',
      desc: '+2 to one ability score, or +1 to two different ability scores. Maximum 20.',
    },
    {
      id: 'grappler',
      name: 'Grappler',
      category: 'general',
      prerequisite: 'Level 4+, STR or DEX 13+',
      repeatable: false,
      asi: { options: ['STR', 'DEX'], amount: 1 },
      desc: "+1 STR or DEX. Punch and Grab: when you hit with an Unarmed Strike as part of the Attack action, you can use both Damage and Grapple option. Attack Advantage: advantage on attacks against creatures you've Grappled. Fast Wrestler: no extra movement cost to move a Grappled creature your size or smaller.",
    },
  ],

  fightingStyle: [
    {
      id: 'archery',
      name: 'Archery',
      category: 'fightingStyle',
      prerequisite: 'Fighting Style feature',
      repeatable: false,
      asi: null,
      desc: '+2 bonus to attack rolls with Ranged weapons.',
    },
    {
      id: 'defense',
      name: 'Defense',
      category: 'fightingStyle',
      prerequisite: 'Fighting Style feature',
      repeatable: false,
      asi: null,
      desc: '+1 to Armor Class while wearing Light, Medium, or Heavy armor.',
    },
    {
      id: 'great_weapon_fighting',
      name: 'Great Weapon Fighting',
      category: 'fightingStyle',
      prerequisite: 'Fighting Style feature',
      repeatable: false,
      asi: null,
      desc: 'When you roll damage for a Melee weapon held with two hands, treat any 1 or 2 on a damage die as a 3. The weapon must have Two-Handed or Versatile property.',
    },
    {
      id: 'two_weapon_fighting',
      name: 'Two-Weapon Fighting',
      category: 'fightingStyle',
      prerequisite: 'Fighting Style feature',
      repeatable: false,
      asi: null,
      desc: 'When you make the extra attack from a Light weapon, you can add your ability modifier to the damage.',
    },
  ],

  epicBoon: [
    {
      id: 'boon_combat_prowess',
      name: 'Boon of Combat Prowess',
      category: 'epicBoon',
      prerequisite: 'Level 19+',
      repeatable: false,
      asi: { options: 'any', amount: 1, max: 30 },
      desc: '+1 to any ability score (max 30). Peerless Aim: when you miss with an attack roll, you can hit instead (once per turn).',
    },
    {
      id: 'boon_dimensional_travel',
      name: 'Boon of Dimensional Travel',
      category: 'epicBoon',
      prerequisite: 'Level 19+',
      repeatable: false,
      asi: { options: 'any', amount: 1, max: 30 },
      desc: '+1 to any ability score (max 30). Blink Steps: immediately after taking the Attack or Magic action, teleport up to 9m to an unoccupied space you can see.',
    },
    {
      id: 'boon_of_fate',
      name: 'Boon of Fate',
      category: 'epicBoon',
      prerequisite: 'Level 19+',
      repeatable: false,
      asi: { options: 'any', amount: 1, max: 30 },
      desc: '+1 to any ability score (max 30). Improve Fate: when you or a creature within 18m succeeds or fails a D20 Test, roll 2d4 and apply as bonus or penalty. Recharges on Initiative or Short/Long Rest.',
    },
    {
      id: 'boon_irresistible_offense',
      name: 'Boon of Irresistible Offense',
      category: 'epicBoon',
      prerequisite: 'Level 19+',
      repeatable: false,
      asi: { options: ['STR', 'DEX'], amount: 1, max: 30 },
      desc: '+1 STR or DEX (max 30). Your weapon and unarmed strike attacks ignore Resistance to Bludgeoning, Piercing, and Slashing damage. On a critical hit, deal extra damage equal to the ability score you increased.',
    },
    {
      id: 'boon_spell_recall',
      name: 'Boon of Spell Recall',
      category: 'epicBoon',
      prerequisite: 'Level 19+, Spellcasting feature',
      repeatable: false,
      asi: { options: ['INT', 'WIS', 'CHA'], amount: 1, max: 30 },
      desc: "+1 INT, WIS, or CHA (max 30). Free Casting: when you cast a spell with a level 1–4 slot, roll 1d4. If the result equals the slot's level, the slot is not expended.",
    },
    {
      id: 'boon_night_spirit',
      name: 'Boon of the Night Spirit',
      category: 'epicBoon',
      prerequisite: 'Level 19+',
      repeatable: false,
      asi: { options: 'any', amount: 1, max: 30 },
      desc: '+1 to any ability score (max 30). In Dim Light or Darkness: gain Invisible condition as Bonus Action (ends after action/bonus/reaction). Shadowy Form: resistance to all damage except Psychic and Radiant while in Dim Light or Darkness.',
    },
    {
      id: 'boon_truesight',
      name: 'Boon of Truesight',
      category: 'epicBoon',
      prerequisite: 'Level 19+',
      repeatable: false,
      asi: { options: 'any', amount: 1, max: 30 },
      desc: '+1 to any ability score (max 30). Truesight: you have Truesight with a range of 18m.',
    },
  ],
};

export const ALL_DND_FEATS = [
  ...DND_FEATS.origin,
  ...DND_FEATS.general,
  ...DND_FEATS.fightingStyle,
  ...DND_FEATS.epicBoon,
];

// Backward compat — LevelUpModal e DNDCharacterCreator importano ORIGIN_FEATS
export const ORIGIN_FEATS = DND_FEATS.origin;
